package com.wintermar.inspection.core.ui.util.modifier

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun Modifier.card(
    backgroundColor: Color = LocalAppTheme.current.color.surface.normal,
    borderColor: Color = LocalAppTheme.current.color.border.subtle,
    radius: Dp = LocalAppTheme.current.dimension.radius.md,
    padding: Dp = LocalAppTheme.current.dimension.spacing.space4
) = this
    .clip(RoundedCornerShape(radius))
    .background(backgroundColor)
    .border(
        width = 1.dp,
        color = borderColor,
        shape = RoundedCornerShape(radius)
    )
    .padding(padding)
